import { motion } from 'framer-motion';
import useText from '@/hooks/useText';
import { FeatureCard } from './FeatureCard';
import { useFoundationCards } from './helpers';

type FoundationsSectionProps = {
  className?: string;
  embedInScrolly?: boolean;
};

export function FoundationsSection({ className, embedInScrolly }: FoundationsSectionProps) {
  const sectionTitle = useText('about_disgenet.foundation.title');
  const cards = useFoundationCards();

  return (
    <section
      className={[
        'about-foundations',
        embedInScrolly && 'about-foundations--scrolly',
        !embedInScrolly && 'mt-8',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="about-foundations__inner">
        {embedInScrolly ? (
          <h2 className="about-foundations__title">{sectionTitle}</h2>
        ) : (
          <motion.h2
            className="about-foundations__title"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            {sectionTitle}
          </motion.h2>
        )}

        <div className="about-foundations__grid">
          {cards.map((card, i) => (
            <FeatureCard
              key={card.title}
              title={card.title}
              points={card.points}
              badgeText={card.badgeText}
              icon={card.icon}
              index={i}
              disableScrollReveal={embedInScrolly}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
